window.dbodhiCountryMapping = {
  "ad": "France",
  "ae": "Turkey",
  "af": "Turkey",
  "ag": "Spain",
  "ai": "Spain",
  "al": "Italy",
  "am": "Turkey",
  "an": "Spain",
  "ao": "Turkey",
  "aq": "Singapore",
  "ar": "Spain",
  "as": "Singapore",
  "at": "Germany",
  "au": "Singapore",
  "aw": "Spain",
  "ax": "Germany",
  "az": "Turkey",
  "ba": "Italy",
  "bb": "Spain",
  "bd": "Singapore",
  "be": "Belgium",
  "bf": "Spain",
  "bg": "Turkey",
  "bh": "Turkey",
  "bi": "Turkey",
  "bj": "Spain",
  "bl": "Spain",
  "bm": "Spain",
  "bn": "Singapore",
  "bo": "Spain",
  "bq": "Spain",
  "br": "Spain",
  "bs": "Spain",
  "bt": "Singapore",
  "bv": "Spain",
  "bw": "Turkey",
  "by": "Germany",
  "bz": "Spain",
  "ca": "Netherlands",
  "cc": "Singapore",
  "cd": "Turkey",
  "cf": "Turkey",
  "cg": "Italy",
  "ch": "France",
  "ci": "Spain",
  "ck": "Singapore",
  "cl": "Spain",
  "cm": "Italy",
  "cn": "Singapore",
  "co": "Spain",
  "cr": "Spain",
  "cu": "Spain",
  "cv": "Spain",
  "cw": "Spain",
  "cx": "Singapore",
  "cy": "Turkey",
  "cz": "Germany",
  "de": "Germany",
  "dj": "Turkey",
  "dk": "Netherlands",
  "dm": "Spain",
  "do": "Spain",
  "dz": "Spain",
  "ec": "Spain",
  "ee": "Germany",
  "eg": "Turkey",
  "eh": "Spain",
  "er": "Turkey",
  "es": "Spain",
  "et": "Turkey",
  "fi": "Germany",
  "fj": "Singapore",
  "fk": "Spain",
  "fm": "Singapore",
  "fo": "Netherlands",
  "fr": "France",
  "ga": "Italy",
  "gb": "Netherlands",
  "gd": "Spain",
  "ge": "Turkey",
  "gf": "Spain",
  "gg": "France",
  "gh": "Spain",
  "gi": "Spain",
  "gl": "Netherlands",
  "gm": "Spain",
  "gn": "Spain",
  "gp": "Spain",
  "gq": "Italy",
  "gr": "Italy",
  "gs": "Spain",
  "gt": "Spain",
  "gu": "Singapore",
  "gw": "Spain",
  "gy": "Spain",
  "gz": "Turkey",
  "hk": "Singapore",
  "hm": "Singapore",
  "hn": "Spain",
  "hr": "Italy",
  "ht": "Spain",
  "hu": "Germany",
  "id": "Singapore",
  "ie": "Netherlands",
  "il": "Turkey",
  "im": "Netherlands",
  "in": "Singapore",
  "io": "Singapore",
  "iq": "Turkey",
  "ir": "Turkey",
  "is": "Netherlands",
  "it": "Italy",
  "je": "France",
  "jm": "Spain",
  "jo": "Turkey",
  "jp": "Singapore",
  "ke": "Turkey",
  "kg": "Turkey",
  "kh": "Singapore",
  "ki": "Singapore",
  "km": "Turkey",
  "kn": "Spain",
  "kp": "Singapore",
  "kr": "Singapore",
  "kw": "Turkey",
  "ky": "Spain",
  "kz": "Turkey",
  "la": "Singapore",
  "lb": "Turkey",
  "lc": "Spain",
  "li": "Germany",
  "lk": "Singapore",
  "lr": "Spain",
  "ls": "Turkey",
  "lt": "Germany",
  "lu": "Belgium",
  "lv": "Germany",
  "ly": "Italy",
  "ma": "Spain",
  "mc": "Italy",
  "md": "Turkey",
  "me": "Italy",
  "mf": "Spain",
  "mg": "Turkey",
  "mh": "Singapore",
  "mk": "Italy",
  "ml": "Spain",
  "mm": "Singapore",
  "mn": "Singapore",
  "mo": "Singapore",
  "mp": "Singapore",
  "mq": "Spain",
  "mr": "Spain",
  "ms": "Spain",
  "mt": "Italy",
  "mu": "Singapore",
  "mv": "Singapore",
  "mw": "Turkey",
  "mx": "Spain",
  "my": "Singapore",
  "mz": "Turkey",
  "na": "Turkey",
  "nc": "Singapore",
  "ne": "Italy",
  "nf": "Singapore",
  "ng": "Italy",
  "ni": "Spain",
  "nl": "Netherlands",
  "no": "Netherlands",
  "np": "Singapore",
  "nr": "Singapore",
  "nu": "Singapore",
  "nz": "Singapore",
  "om": "Turkey",
  "pa": "Spain",
  "pe": "Spain",
  "pf": "Singapore",
  "pg": "Singapore",
  "ph": "Singapore",
  "pk": "Turkey",
  "pl": "Germany",
  "pm": "Spain",
  "pn": "Singapore",
  "pr": "Spain",
  "ps": "Turkey",
  "pt": "Spain",
  "pw": "Singapore",
  "py": "Spain",
  "qa": "Turkey",
  "re": "Singapore",
  "ro": "Italy",
  "rs": "Italy",
  "ru": "Turkey",
  "rw": "Turkey",
  "sa": "Turkey",
  "sb": "Singapore",
  "sc": "Turkey",
  "sd": "Turkey",
  "se": "Germany",
  "sg": "Singapore",
  "sh": "Spain",
  "si": "Italy",
  "sj": "Netherlands",
  "sk": "Germany",
  "sl": "Spain",
  "sm": "Italy",
  "sn": "Spain",
  "so": "Turkey",
  "sr": "Spain",
  "st": "Spain",
  "sv": "Spain",
  "sx": "Spain",
  "sy": "Turkey",
  "sz": "Turkey",
  "tc": "Spain",
  "td": "Italy",
  "tf": "Singapore",
  "tg": "Spain",
  "th": "Singapore",
  "tj": "Turkey",
  "tk": "Singapore",
  "tl": "Singapore",
  "tm": "Turkey",
  "tn": "Italy",
  "to": "Singapore",
  "tr": "Turkey",
  "tt": "Spain",
  "tv": "Singapore",
  "tw": "Singapore",
  "tz": "Turkey",
  "ua": "Turkey",
  "ug": "Turkey",
  "um": "Spain",
  "us": "Netherlands",
  "uy": "Spain",
  "uz": "Turkey",
  "va": "Italy",
  "vc": "Spain",
  "ve": "Spain",
  "vg": "Spain",
  "vi": "Spain",
  "vn": "Singapore",
  "vu": "Singapore",
  "wf": "Singapore",
  "ws": "Singapore",
  "xk": "Italy",
  "ye": "Turkey",
  "yt": "Turkey",
  "za": "Turkey",
  "zm": "Turkey",
  "zw": "Turkey"
};
